<template>
  <div>
    <template v-if="!isOfficeLogin">
      <AttendancesMobile v-model="onboardingMobileActive" />
      <AttendancesDesktop v-model="onboardingDesktopActive" :isEmpty="Object.keys(groupedAttendances).length === 0 && groupedAttendances.constructor === Object
        " />
      <AttendancesOnlyMobile v-model="onboardingOnlyMobileActive" />
      <AttendancesOnlyDesktop v-model="onboardingOnlyDesktopActive" :isEmpty="Object.keys(groupedAttendances).length === 0 && groupedAttendances.constructor === Object
        " />
    </template>
    <div class="attendances">
      <img class="attendances__logo-mobile" src="@/assets/images/brand/logo.svg" />
      <img class="attendances__logo-desktop" src="@/assets/images/brand/logo_full.svg" />
      <div class="attendances__container">
        <div class="attendances__header">
          <h3 class="attendances__title">
            {{ $t("dashboard.attendances") }}
          </h3>
          <button v-if="(isFullAccess) && !isLoading" @click="startOnlyOnboarding" class="onboarding-button">
            <div class="flex items-center">
              <img id="classes-homework" src="@/assets/images/icons/i_pink.svg" />
              <p class="ml-2 text-pink-main text-lg font-medium">Zobacz jak to działa</p>
            </div>
          </button>
        </div>
        <Loader v-if="isLoading" />
        <AttendancesEmptyState v-if="!isLoading && (!isFullAccess || !attendances.length)" />
        <AttendancesList v-else-if="groupedAttendances" :attendances="groupedAttendances" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {
  mapActions, mapState, mapMutations, mapGetters,
} from 'vuex';

import AttendancesList from '@/components/AttendancesList/AttendancesList.vue';
import Loader from '@/components/Loader.vue';

import AttendancesMobile from '@/components/Popup/AttendancesMobile.vue';
import AttendancesDesktop from '@/components/Popup/AttendancesDesktop.vue';
import AttendancesOnlyMobile from '@/components/Popup/AttendancesOnlyMobile.vue';
import AttendancesOnlyDesktop from '@/components/Popup/AttendancesOnlyDesktop.vue';
import AttendancesEmptyState from '../../components/AttendancesList/AttendancesEmptyState.vue';

export default {
  name: 'Attendances',
  components: {
    AttendancesList,
    AttendancesMobile,
    AttendancesDesktop,
    AttendancesOnlyMobile,
    AttendancesOnlyDesktop,
    Loader,
    AttendancesEmptyState,
  },

  data() {
    return {
      windowWidth: 0,
      isLoading: false,
      groupedAttendances: {},
      modalOpen: true,
      onboardingMobileActive: false,
      onboardingDesktopActive: false,
      onboardingOnlyMobileActive: false,
      onboardingOnlyDesktopActive: false,
    };
  },

  computed: {
    ...mapState('students', ['student']),
    ...mapState('attendances', ['attendances']),
    ...mapGetters('auth', [
      'isOfficeLogin',
      'isFullAccess',
    ]),
    ...mapGetters('onboarding', [
      'getOnboardingProperty',
    ]),
    isMobileOnboardingDone() {
      return this.getOnboardingProperty({ deviceType: 'mobile', property: 'attendance' });
    },
    isDesktopOnboardingDone() {
      return this.getOnboardingProperty({ deviceType: 'desktop', property: 'attendance' });
    },
  },

  methods: {
    ...mapActions('attendances', ['getAttendances']),
    ...mapActions('students', ['updateStudent']),
    ...mapActions('lessons', ['clearLesson', 'clearLessons']),
    ...mapActions('attendances', ['clearAttendances']),
    ...mapMutations('layout', ['closeSidebar']),
    ...mapMutations('layout', ['showClassList', 'hideClassList']),

    close() {
      this.closeSidebar();
    },

    getWindowWidth() {
      this.windowWidth = window.innerWidth;
      Event.$emit('cancelTour');
      this.onboardingMobileActive = false;
      this.onboardingDesktopActive = false;
      this.onboardingOnlyMobileActive = false;
      this.onboardingOnlyDesktopActive = false;
    },

    async getData(params = {}) {
      // TODO TEMPORARY CHANGE
      // Mocked fixed dates
      // const dateFrom = moment('2025-08-26', 'YYYY-MM-DD');
      // const dateTo = moment('2026-06-30', 'YYYY-MM-DD');
      const dateFrom = moment('0901', 'MMDD');
      const dateTo = moment('0831', 'MMDD');
      if (dateFrom.month() > moment().month()) {
        dateFrom.subtract(1, 'year');
      } else {
        dateTo.add(1, 'year');
      }

      if (this.student?.id) {
        await this.getAttendances({
          studentId: this.student.id,
          payload: Object.assign(
            {
              dateFrom: dateFrom.format('YYYY-MM-DD'),
              dateTo: dateTo.format('YYYY-MM-DD'),
            },
            params,
          ),
        });
      }

      this.groupAttendances();
    },

    openModal() {
      this.modalOpen = !this.modalOpen;
    },

    groupAttendances() {
      const groupedAttendances = {};
      this.attendances.forEach((attendance) => {
        const date = moment(attendance.lesson.date);
        const monthName = date.format('YYYY-MM');
        if (Object.prototype.hasOwnProperty.call(groupedAttendances, monthName)) {
          groupedAttendances[monthName].push(attendance);
        } else {
          groupedAttendances[monthName] = [attendance];
        }
      });

      const sortable = [];
      Object.keys(groupedAttendances).forEach((key) => {
        sortable.push([key, groupedAttendances[key]]);
      });
      sortable.sort().reverse();

      this.groupedAttendances = {};
      sortable.forEach((item) => {
        // eslint-disable-next-line prefer-destructuring
        this.groupedAttendances[item[0]] = item[1];
      });
    },

    startDesktopOnboarding() {
      this.close();
      this.onboardingDesktopActive = !this.onboardingDesktopActive;
    },

    startMobileOnboarding() {
      this.close();
      this.onboardingMobileActive = !this.onboardingMobileActive;
    },

    startOnlyOnboarding() {
      this.close();
      if (this.windowWidth < 992) {
        this.onboardingOnlyMobileActive = !this.onboardingOnlyMobileActive;
      } else {
        this.onboardingOnlyDesktopActive = !this.onboardingOnlyDesktopActive;
      }
    },

    checkIfTourCookieExist() {
      if (!this.student?.id || !this.student?.onboardingMobile || !this.student?.onboardingDesktop) return;

      setTimeout(() => {
        const { group } = this.student || {};
        if (!group) return;

        const isMobile = this.windowWidth < 992;
        const { hasHomeworks } = group;


        const profileMobileOnboarding = this.student?.onboardingMobile?.attendance;
        const profileDesktopOnboarding = this.student?.onboardingDesktop?.attendance;

        if (isMobile) {
          if (hasHomeworks && !profileMobileOnboarding) {
            this.startMobileOnboarding();
          } else if (!this.isMobileOnboardingDone) {
            this.openModal();
          }
        } else if (hasHomeworks && !profileDesktopOnboarding) {
          this.startDesktopOnboarding();
        } else if (!this.isDesktopOnboardingDone) {
          this.openModal();
        }

        this.showClassList();
      }, 500);
    },
  },

  mounted() {
    this.windowWidth = window.innerWidth;
    window.addEventListener('resize', this.getWindowWidth);
  },

  async created() {
    if (!this.student || Object.keys(this.student).length === 0) {
      this.routerPush({ name: 'Auth.Welcome' });
    } else if (!this.isFullAccess) {
      this.isLoading = false;
      this.showClassList();
    } else {
      this.hideClassList();
      this.isLoading = true;
      this.clearLesson();
      this.clearLessons();
      this.clearAttendances();

      try {
        await this.updateStudent(this.student.id);
        if (this.student === null) {
          this.routerPush({ name: 'Auth.Welcome' });
          return;
        }
        await this.getData();
        await this.checkIfTourCookieExist();
      } catch (err) {
        console.log('Attendances:', err);
      } finally {
        this.isLoading = false;
      }
    }
  },


  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  },
};
</script>

<style lang="scss">
.attendances {
  @apply min-h-full pb-32 relative;
  overflow: hidden;
  padding-top: 30px;
  z-index: 1;

  @media screen and (min-width: 992px) {
    margin-left: 312px;
  }

  &__container {
    @apply mx-auto w-full pt-8 px-4;
    padding-bottom: 120px;

    @media screen and (min-width: 992px) {
      padding-right: 40px;
      padding-bottom: 30px;
      padding-left: 78px;
    }
  }

  &__logo-mobile {
    @apply w-14 h-14 mx-auto block;

    @media screen and (min-width: 992px) {
      @apply hidden;
    }
  }

  &__logo-desktop {
    @apply mt-4 block;

    @media screen and (max-width: 991px) {
      @apply hidden;
    }

    @media screen and (min-width: 992px) {
      transform: translateX(78px);
    }
  }

  &__header {
    @apply flex flex-col items-start pb-8;

    @media screen and (min-width: 992px) {
      @apply flex-row items-center text-4xl;
    }

    .onboarding-button {
      @apply ml-0 mt-4;
      white-space: nowrap;

      @media screen and (min-width: 992px) {
        @apply mt-1 ml-4;
      }
    }
  }

  &__title {
    @apply text-2xl font-semibold mb-0;
    white-space: nowrap;

    @media screen and (min-width: 992px) {
      @apply text-4xl;
    }
  }
}
</style>
